import React , {useContext , useState} from 'react'
import "./coupons.css"
import { FaArrowRight } from 'react-icons/fa';
import couponLottie from  "../../../../assets/lottie/coupons.json" ;
import Lottie from "lottie-react";
import UserContext from '../../../../context/user_context';
import CouponsSheet from './CouponsSheet';
import ValidCoupon from './ValidCoupon';
import CartContext from '../../../../context/cart_context';


const Coupons = () => {
  const {  userInfo} = useContext(UserContext);  
  const {setCouponAmount ,couponAmount , selectedCoupon, setSelectedCoupon } = useContext(CartContext);
  const [showCoupons, setShowCoupons] = useState(false);
  const [showValidCoupon, setShowValidCoupon] = useState(true);

  return (
    userInfo != null &&
    <>
      <div  onClick={() => setShowCoupons(true)}  className='checkout-item-container coupon-container' >
        <Lottie animationData={couponLottie} className="coupon-lottie"   />
        {
         !( couponAmount > 0  && selectedCoupon != null ) 
        ?(
          <>
            <p>Apply Coupons</p>
            <FaArrowRight />
          </>

        ): (
          <>
            <p>{selectedCoupon.couponCode}</p>
            <span onClick={() => {
              setCouponAmount(0);
              setSelectedCoupon(null);
            }} >Remove</span>
          </>
        )

        }
      </div>
      {
        showCoupons && (<CouponsSheet setShowCoupons={setShowCoupons} setShowValidCoupon={setShowValidCoupon} setSelectedCoupon={setSelectedCoupon}   />)
      }
      {
        (showValidCoupon  && selectedCoupon != null )  && (<ValidCoupon  setShowValidCoupon={setShowValidCoupon}  selectedCoupon={selectedCoupon}  />)
      }
    </>
  )
}

export default Coupons